module.exports = __webpack_public_path__ + "static/media/header-services-bg.f90f92c7.png";